import { Directive, ElementRef, Inject, Input, OnInit } from '@angular/core'
import { AuthContextStorageService } from './auth-context-storage.service'

@Directive({
    selector: '[cmAuth]',
    standalone: false
})
export class CmAuthDirective implements OnInit {
    @Input() cmAuth: string

    constructor(@Inject(ElementRef) private el: ElementRef,
                @Inject(AuthContextStorageService) private authContextStorageService: AuthContextStorageService) {
    }

    ngOnInit(): void {
        const display = this.authContextStorageService.hasPermission(this.cmAuth)

        if (!display) {
            this.el.nativeElement.remove()
        }
    }
}